export default __webpack_public_path__ + "static/media/img-0082-japan-full-face.01dfa8a5.png";